module.exports = __webpack_public_path__ + "static/3-1fd2e66872428ef7391b36ab941480b1.jpg";